import { liftPlanService } from '@/services/lift-plan/lift-plan-service.ts';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type { models } from 'cesg-shared';

export const useLiftPlanMutation = (projectId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['liftPlanService', 'put', projectId],
    mutationFn: ({ body }: { body: models.PutLiftPlanBody }) =>
      liftPlanService.put(projectId, body),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: projectKeys.liftPlan({ projectId }) }),
  });
};
